import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const tasks: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8-1h5v-1H8ZM5-5h8v-1H5Zm5-4h3v-1h-3zm4 6.5v2a.5.5 0 0 1-.156.36.47.47 0 0 1-.344.14H.5a.52.52 0 0 1-.36-.14A.52.52 0 0 1 0-.5v-2q0-.201.14-.344A.5.5 0 0 1 .5-3h13c.133 0 .25.055.344.156.101.094.156.211.156.344m0-4v2a.5.5 0 0 1-.156.36.47.47 0 0 1-.344.14H.5a.52.52 0 0 1-.36-.14A.52.52 0 0 1 0-4.5v-2q0-.201.14-.344A.5.5 0 0 1 .5-7h13c.133 0 .25.055.344.156.101.094.156.211.156.344m0-4v2a.5.5 0 0 1-.156.36.47.47 0 0 1-.344.14H.5a.52.52 0 0 1-.36-.14A.52.52 0 0 1 0-8.5v-2q0-.201.14-.344A.5.5 0 0 1 .5-11h13c.133 0 .25.055.344.156.101.094.156.211.156.344m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "14",
  }
};
